
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5eaa5a33&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReplacementGoods.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReplacementGoods.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5eaa5a33!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReplacementGoods.vue"),
  /* scopeId */
  "data-v-5eaa5a33",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ReplacementGoods.vue
// module id = 295
// module chunks = 1